import { render, staticRenderFns } from "./Committemember.vue?vue&type=template&id=bf32f70c&scoped=true"
import script from "./Committemember.vue?vue&type=script&lang=js"
export * from "./Committemember.vue?vue&type=script&lang=js"
import style0 from "./Committemember.vue?vue&type=style&index=0&id=bf32f70c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf32f70c",
  null
  
)

export default component.exports